import { Configuration } from './../../models/Configuration';
import { Action } from "../../models/Action";
import { getConfigurationFacility, updateFacilityIds } from "./configActions";

declare const config: { FACILITY_IDS: string };
export const FACILITY_IDS = (config && config.FACILITY_IDS) || "";

export interface ConfigState {
  facilityIds: string;
  facilityLogoUrl: string;
  configuration: Configuration;
}

const initialConfig: ConfigState = {
  facilityIds: FACILITY_IDS,
  facilityLogoUrl: "",
  configuration: {} as Configuration
};

export default function configReducer(authState = initialConfig, action: Action<any>) {
  switch (action.type) {

      case updateFacilityIds.toString():
        return {
          ...authState,
          facilityIds:  action.payload
        };
        case getConfigurationFacility.fulfilled.toString():
          return {
            ...authState,
            facilityLogoUrl: action.payload.logoUrl,
            configuration: action.payload,
          }
    default:
      return authState;
  }
}
